import {makeAutoObservable, runInAction} from "mobx";
import {ICreateRMAResponse} from "../../../services/api/create-rma-service";
import IframeService from "../../../services/iframe-service/iframe-service";
import { rootContainer, TYPE } from "../../../services/container/root";

export default class CreateRmaResponseStore {
    private _model: ICreateRMAResponse = {} as ICreateRMAResponse;
    private _timer: number = 6;
    private _abortTimer: boolean = false;

    constructor(model: ICreateRMAResponse) {
        makeAutoObservable(this, {}, {autoBind: true});
        this._model = model;
        this._startTimer();
    }

    private get _iframeService(): IframeService { return rootContainer.get<IframeService>(TYPE.IframService); }

    public get rmaId(): string { return (this._model.created_rma?.rma_code ?? '').replace('RMA', ''); }
    public get success(): boolean { return this._model.success; }
    public get message(): string { return this._model.message; }
    public get messageTitle(): string { return this._model.message_title; }
    public get warningMessage(): string { return  this._model.warning_message ?? ''; }

    openCreatedRma() {
        this.abortTimer();
        this._iframeService.redirectParentFrame('/dashboard/returns?rmaid=' + this.rmaId);
    }

    private _startTimer(){
        if(!this._model.success){
            this.abortTimer();
        }
        let interval = setInterval(() => {
            runInAction(() => {
                this._timer--;
            })
            if(this._abortTimer){
                clearInterval(interval);
            }
            if(this._timer === 0 && !this._abortTimer){
                this.openCreatedRma();
                clearInterval(interval);
            }
        }, 1000);
    }

    getTimer(): string {
        return this._timer > 0 ? `(${this._timer})` : '';
    }
    public abortTimer(){ this._abortTimer = true; }
}
